import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class CompanyOnboardService {
  static onboardCompany(key,params) {
    return HttpUtil.post(API_ROUTES.COMPANYONBOARD.ONBOARD+`${key}/onboard`,params);
  }
 
}
